import axios from 'axios';
import type {
  IContact,
  IContactUpdateRequest,
  IContactUpdateResponse,
} from '@bb/contacts';

import type { ContactUpdatePayload } from './types';

const updateContact = async <T extends IContact>(
  id: string,
  payload: ContactUpdatePayload<T>,
) => {
  const config: IContactUpdateRequest = {
    url: `/contacts/${id}`,
    method: 'post',
    data: payload,
  };
  const { data } = await axios.request<IContactUpdateResponse>(config);

  return data;
};

export default updateContact;
